<script setup lang="ts">
import type { CmsBlockImageTextBubble } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockImageTextBubble;
}>();

const { getSlotContent } = useCmsBlock(props.content);

const leftText = getSlotContent("left-text");
const leftImage = getSlotContent("left-image");
const centerText = getSlotContent("center-text");
const centerImage = getSlotContent("center-image");
const rightText = getSlotContent("right-text");
const rightImage = getSlotContent("right-image");
</script>
<template>
  <div class="container">
    <div class="grid md:grid-cols-3 lg:grid-cols-3 gap-y-24 lg:gap-y-16 md:gap-x-[40px] mob320_gap">
      <div class="">
        <div class="flex">
          <CmsGenericElement
              :content="leftImage"
              class="object-center rounded-full"
              :style="{ height: '120px', width: '120px', 'min-height': '150px' }"
          />
        </div>
        <CmsGenericElement :content="leftText" />
      </div>
      <div>
        <div class="flex">
          <CmsGenericElement
              :content="centerImage"
              class="object-center rounded-full"
              :style="{ height: '120px', width: '120px' , 'min-height': '150px'}"
          />
        </div>
        <CmsGenericElement :content="centerText" />
      </div>
      <div>
        <div class="flex">
          <CmsGenericElement
              :content="rightImage"
              class="object-center rounded-full"
              :style="{ height: '120px', width: '120px', 'min-height': '150px' }"
          />
        </div>
        <CmsGenericElement :content="rightText" />
      </div>
    </div>
  </div>
</template>
